import BaseParser from './BaseParser';
import _get from 'lodash/get';

import Quantity from './Quantity';
import { BaseParserOptions, RatioOptions } from './SharedTypes';

class Ratio extends BaseParser {
  private quantityParser: Quantity;

  /**
   * @param {Quantity} options.ratio.quantityParser - Parser used for numerator and denominator of ratio
   */
  constructor(options: BaseParserOptions = {}) {
    super();

    const ratioOptions = _get<BaseParserOptions, 'ratio', RatioOptions>(
      options,
      'ratio',
      // @ts-expect-error This directive was added as part of a bulk-change to enable strictNullChecks.
      null,
    );
    this.quantityParser = _get<RatioOptions, 'quantityParser', Quantity>(
      ratioOptions,
      'quantityParser',
      new Quantity(),
    );
  }

  // @ts-expect-error This directive was added as part of a bulk-change to enable strictNullChecks.
  getDisplayValue(fhirProperty: fhir.Ratio) {
    if (!fhirProperty) return null;

    const numerator = _get<fhir.Ratio, 'numerator', fhir.Quantity>(
      fhirProperty,
      'numerator',
      // @ts-expect-error This directive was added as part of a bulk-change to enable strictNullChecks.
      null,
    );
    const denominator = _get<fhir.Ratio, 'denominator', fhir.Quantity>(
      fhirProperty,
      'denominator',
      // @ts-expect-error This directive was added as part of a bulk-change to enable strictNullChecks.
      null,
    );

    const numeratorDisplay =
      this.quantityParser.getDisplayValue(numerator) || 'N/A';
    const denominatorDisplay =
      this.quantityParser.getDisplayValue(denominator) || 'N/A';

    return `${numeratorDisplay} / ${denominatorDisplay}`;
  }

  // @ts-expect-error This directive was added as part of a bulk-change to enable strictNullChecks.
  getSortValue(fhirProperty: fhir.Ratio) {
    if (!fhirProperty) return null;

    const numerator = _get<fhir.Ratio, 'numerator', fhir.Quantity>(
      fhirProperty,
      'numerator',
      // @ts-expect-error This directive was added as part of a bulk-change to enable strictNullChecks.
      null,
    );
    const denominator = _get<fhir.Ratio, 'denominator', fhir.Quantity>(
      fhirProperty,
      'denominator',
      // @ts-expect-error This directive was added as part of a bulk-change to enable strictNullChecks.
      null,
    );

    const numeratorSortValue = this.quantityParser.getSortValue(numerator);
    const denominatorSortValue = this.quantityParser.getSortValue(denominator);

    // return null for invalid denominator or null numerator or denominator
    if (
      denominatorSortValue === null ||
      denominatorSortValue === 0 ||
      numeratorSortValue === null
    ) {
      return null;
    }

    return numeratorSortValue / denominatorSortValue;
  }
}

export default Ratio;
